import { mdiCash } from '@mdi/js'

export default [
  {
    title: 'حسابداری',
    icon: mdiCash,
    action: 'can_see_and_edit_accounting',
    resource: 'all',
    children: [
      {
        title: 'تنظیمات',
        to: 'accounting_settings',
        action: 'can_see_and_edit_accounting',
        resource: 'all',
      },
      {
        title: 'سال مالی',
        to: 'accounting_financial_year',
        action: 'can_see_and_edit_accounting',
        resource: 'all',
      },
      {
        title: 'ثبت محصولات ',
        to: 'accounting_products',
        action: 'can_see_and_edit_accounting',
        resource: 'all',
      },
      {
        title: 'مخاطبین',
        to: 'accounting_contacts',
        action: 'can_see_and_edit_accounting',
        resource: 'all',
      },
      {
        title: 'بانک ها',
        to: 'accounting_banks',
        action: 'can_see_and_edit_accounting',
        resource: 'all',
      },
      {
        title: 'مشاهده اطلاعات',
        to: 'accounting_sync',
        action: 'can_see_and_edit_accounting',
        resource: 'all',
      },
    ],
  },
]
